module.exports = __webpack_public_path__ + "static/img/agency-logo.055b0de0.svg";